export default "__VITE_ASSET__CEga1ysd__"